(function createTripSummaryForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderTemplateCreateTripSummary',
	};

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// toggle global/custom banner fields
		$('.image-type > .btn-radio').click(function _imageTypeClicked() {
			var data_type = $(this).data('type');

			if (data_type === 'global') {
				// global banner
				$('.global-banner').removeClass('hidden');
				$('.custom-banner').addClass('hidden');
			} else {
				// custom banner
				$('.global-banner').addClass('hidden');
				$('.custom-banner').removeClass('hidden');
			}
		});

		// custom banner
		$('.remove-banner').click(function _removeCustomBanner(e) {
			e.preventDefault();

			$('#fitbuildertemplatecreatetripsummary-image_name').val('');
			$('#fitbuildertemplatecreatetripsummary-remove_banner').val('1');
			$('.selected-banner').attr('src', '');

			$('.selected-banner-remove').addClass('hidden');
		});

		// main picture
		$('.fit-builder-template-library-select').click(function _showImagePicker(e) {
			e.preventDefault();

			showImagePicker();
		});

		$('.remove-image').click(function _removeLibraryImage(e) {
			e.preventDefault();

			$('#fitbuildertemplatecreatetripsummary-picture').val('');
			$('#fitbuildertemplatecreatetripsummary-library_image').val('');
			$('#fitbuildertemplatecreatetripsummary-remove_picture').val('1');
			$('.selected-image').attr('src', '');

			$('.selected-image-remove').addClass('hidden');
		});

		// set client based on sales opp
		$('.opportunity-client-name').change(function _setClient() {
			var client_id   = $('.opportunity-client-id').val(),
			    client_name = $('.opportunity-client-name').val();

			if (client_id === '') {
				// reset the client fields
				$('#fitbuildertemplatecreatetripsummary-client_id').val('');
				$('#fitbuildertemplatecreatetripsummary-client_search').val('');
				$('#fitbuildertemplatecreatetripsummary-client_search').prop('disabled', false);
				$('.reset-client').addClass('hidden');
			} else {
				// set the client fields to the sales opp client
				$('#fitbuildertemplatecreatetripsummary-client_id').val(client_id);
				$('#fitbuildertemplatecreatetripsummary-client_search').val(client_name);
				$('#fitbuildertemplatecreatetripsummary-client_search').prop('disabled', true);
				$('.reset-client').removeClass('hidden');
			}
		});

		// client typeahead
		Adzuki.Typeahead(
			'#fitbuildertemplatecreatetripsummary-client_search',
			'/Clients/search',
			function select(item) {
				$('#fitbuildertemplatecreatetripsummary-client_id').val(item.id);
				$('#fitbuildertemplatecreatetripsummary-client_search').val(item.full_name);
				$('#fitbuildertemplatecreatetripsummary-client_search').prop('disabled', true);

				$('.reset-client').removeClass('hidden');
			},
			function template(item) {
				var html;

				if (item.result_name) {
					html = item.result_name;
				} else {
					html = item.full_name;
				}

				html += item.age;

				return html;
			}
		);

		$('#reset-client-link').click(function _resetClient(e) {
			e.preventDefault();

			$('#fitbuildertemplatecreatetripsummary-client_id').val('');
			$('#fitbuildertemplatecreatetripsummary-client_search').val('');
			$('#fitbuildertemplatecreatetripsummary-client_search').prop('disabled', false);
			$('.reset-client').addClass('hidden');
		});

		// init the component field listeners
		$('.component-container').each(function onEachComponentElement(i, elem) {
			var day          = $(elem).data('day'),
				component    = $(elem).data('component'),
				component_id = $(elem).data('component_id');

			// attach events
			initComponentFieldListeners(day, component, component_id);
		});

		// update component dates based on overall start date
		$('.travel-start-date').on('dp.change', function travelStartDateChange(e) {
			var val = $(this).val();

			if (val.length > 0) {
				$('.add-start').each(function onEachComponentDateElement(i, elem) {
					var day            = $(elem).data('day'),
						component      = $(elem).data('component'),
						component_id   = $(elem).data('component_id'),
						component_type = $('.component-type[data-day="' + day + '"][data-component="' + component + '"]').val(),
						add_days       = (Number(day)-1),
						val_date       = moment(val, "MM/DD/YYYY").add(add_days, 'days'),
						start_time,
						end_time;

					$('.add-start[data-day="' + day + '"][data-component="' + component + '"]').data('DateTimePicker').date(val_date);

					if (component_type === 'lodging') {
						start_time = moment().hour(15).minute(0).second(0);
						end_time   = moment().hour(11).minute(0).second(0);

						$('#fitbuildertemplatecreatetripsummary-components-' + component_id + '-component_start_date-time').data("DateTimePicker").date(start_time);
						$('#fitbuildertemplatecreatetripsummary-components-' + component_id + '-component_end_date-time').data("DateTimePicker").date(end_time);
					}
				});
			}
		});
	};

	function getAllInclusiveProperties(day, component, vendor_id)
	{
		var $properties_select = $('.ai-property-select[data-day="' + day + '"][data-component="' + component + '"]'),
		    property_id;

		// reset stuff
		$properties_select.empty();
		$properties_select.append($('<option>').text('').attr('value', ''));

		// get properties based on the vendor ID
		Adzuki.Ajax.get('/AllInclusiveProperties/getProperties/' + vendor_id).then(function success(properties) {
			var sorted_properties = Adzuki.Sort.alphabeticValue(properties);

			if (sorted_properties.length > 0) {
				// we have all-inclusives, build select options
				$.each(sorted_properties, function loadProperty(i, property) {
					$properties_select.append($('<option>').text(property.value).attr('value', property.key));
				});

				if (typeof $properties_select.data('selected-id') !== 'undefined') {
					property_id = $properties_select.data('selected-id');
					$properties_select.removeAttr('data-selected-id');
					$properties_select.removeData('selected-id');

					$properties_select.val(property_id);
				}

				$('.ai-property-select[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
				$('.component-ai-property[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			} else {
				// no all-inclusives, so show hotel search field
				$('.component-hotel[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$('.component_hotels[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
			}
		});
	}

	function getShips(day, component, vendor_id)
	{
		var $ships_select = $('.ship-select[data-day="' + day + '"][data-component="' + component + '"]'),
		    ship_id;

		// reset stuff
		$ships_select.empty();
		$ships_select.append($('<option>').text('').attr('value', ''));

		// get ships based on the vendor ID
		Adzuki.Ajax.get('/Ships/shipsByVendor/' + vendor_id).then(function success(ships) {
			if (ships.length > 0) {
				// we have ships, build select options
				$.each(ships, function loadShip(i, ship) {
					$ships_select.append($('<option>').text(ship.name).attr('value', ship.id));
				});

				if (typeof $ships_select.data('selected-id') !== 'undefined') {
					ship_id = $ships_select.data('selected-id');
					$ships_select.removeAttr('data-selected-id');
					$ships_select.removeData('selected-id');

					$ships_select.val(ship_id);
				}

				$('.ship-select[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
				$('.component-ship[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			}
		});
	}

	function initComponentFieldListeners(day, component, component_id)
	{
		var field_id = '#fitbuildertemplatecreatetripsummary-components-' + component_id + '-';

		// attach events
		// vendors
		loadVendorTypeAhead(day, component, component_id);
		resetVendorTypeAhead(day, component, component_id);

		// hotels
		loadHotelTypeAhead(day, component, component_id);
		resetHotelTypeAhead(day, component, component_id);

		// viator
		loadViatorDestinationTypeAhead(day, component, component_id);
		resetViatorTypeAheads(day, component, component_id);

		// handle booked through change
		$('.packaged-by[data-day="' + day + '"][data-component="' + component + '"] > .btn-radio').click(function _packagedByClicked() {
			var data_type   = $(this).data('type'),
				is_disabled = $(this).hasClass('disabled');

			// don't do anything if field has disabled class
			if (is_disabled === true) {
				return false;
			}

			if (data_type === 'supplier') {
				// package supplier
				$('.component-vendor-required[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$('.component-package-vendor[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$(field_id + 'package_vendor_id').prop('disabled', false);
			} else {
				// direct
				$('.component-vendor-required[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$('.component-package-vendor[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
				$(field_id + 'package_vendor_id').prop('disabled', true);
			}
		});

		// set sailing options based on ship
		$('.ship-select[data-day="' + day + '"][data-component="' + component + '"]').change(function _loadShipInfo() {
			var $sailing_select = $('.sailing-select[data-day="' + day + '"][data-component="' + component + '"]'),
			    ship_id         = $(this).val(),
			    sailing_id,
			    key_parts,
			    value_parts,
			    travel_start_date = '',
			    sailing_date = '';

			// reset stuff
			$sailing_select.empty();
			$sailing_select.append($('<option>').text('').attr('value', ''));

			Adzuki.Ajax.get('/CruiseSearch/getSailings/' + ship_id + '/0/1').then(function success(sailings) {
				if ($.isEmptyObject(sailings) === false) {
					travel_start_date = $('.travel-start-date').val();

					if (travel_start_date !== '') {
						travel_start_date = moment(travel_start_date, "MM/DD/YYYY").add(0, 'days');
					}

					// we have sailings, build select options
					$.each(sailings, function loadSailing(key, value) {
						key_parts    = key.split("|");
						value_parts  = value.split(" - ");
						sailing_date = moment(value_parts[0], "MM/DD/YYYY").add(0, 'days');

						if (travel_start_date === '' || sailing_date >= travel_start_date) {
							$sailing_select.append($('<option>').text(value).attr('value', key_parts[1]));
						}
					});

					if (typeof $sailing_select.data('selected-id') !== 'undefined') {
						sailing_id = $sailing_select.data('selected-id');

						$sailing_select.removeAttr('data-selected-id');
						$sailing_select.removeData('selected-id');
						$sailing_select.val(sailing_id);
					}

					$(field_id + 'itinerary_id').prop('disabled', false);
					$('.component-sailing[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				}
			});
		});

		// set component end date based on sailing selection
		$('.sailing-select[data-day="' + day + '"][data-component="' + component + '"]').change(function _loadSailingInfo() {
			var itinerary_id = $(this).val();

			Adzuki.Ajax.get('/FitBuilders/sailing/' + itinerary_id).then(function success(data) {
				$('.add-start[data-day="' + day + '"][data-component="' + component + '"]').data('DateTimePicker').date(data.start_date);
				$('.add-end[data-day="' + day + '"][data-component="' + component + '"]').data('DateTimePicker').date(data.end_date);
			});
		});

		// set component end date based on start date selection
		$('.add-start[data-day="' + day + '"][data-component="' + component + '"]').on('dp.change', function dateChange(e) {
			var val            = $(this).val(),
				val_date       = moment(val, "MM/DD/YYYY").add(1, 'days'),
				component_type = $('.component-type[data-day="' + day + '"][data-component="' + component + '"]').val();

			if (val.length > 0) {
				if (component_type === 'excursion' || component_type === 'transfer' || component_type === 'custom') {
					$('.add-end[data-day="' + day + '"][data-component="' + component + '"]').data('DateTimePicker').date(val);
				} else {
					$('.add-end[data-day="' + day + '"][data-component="' + component + '"]').data('DateTimePicker').date(val_date);
				}
			}
		});
	}

	function loadHotelTypeAhead(day, component, component_id)
	{
		var field_id = '#fitbuildertemplatecreatetripsummary-components-' + component_id + '-';

		Adzuki.Typeahead(
			field_id + 'hotel_search',
			'/Searches/hotelSearch/',
			function select(item, $self, typeahead) {
				var hotel_search_val = '';

				// handle response
				typeahead.setHiddenValue(item.id);

				if (item.city) {
					hotel_search_val = item.name + ' (' + item.city + ', ' + item.country_code + ')';
				} else {
					hotel_search_val = item.name;
				}

				// set the search field value, disable, and show reset link
				$(field_id + 'hotel_search').val(hotel_search_val);
				$(field_id + 'hotel_search').prop('disabled', true);

				$('.reset-hotel-typeahead[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

				// set hidden hotel_giata_id
				$(field_id + 'hotel_giata_id').val(item.giata_id);
				$(field_id + 'hotel_giata_id').prop('disabled', false);
			},
			function template(item) {
				var html;

				if (item.city) {
					html = item.name + ' (' + item.city + ', ' + item.country_code + ')';
				} else {
					html = item.name;
				}

				return html;
			}
		);
	}

	function loadVendorTypeAhead(day, component, component_id)
	{
		var field_id          = '#fitbuildertemplatecreatetripsummary-components-' + component_id + '-',
			component_type    = $(field_id + 'component_type').val(),
			vendor_lookup_url = '/Vendors/searchVendorByType/' + component_type + '/';

		Adzuki.Typeahead(
			field_id + 'vendor_search',
			vendor_lookup_url,
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				$(field_id + 'vendor_id').prop('disabled', false);
				$(field_id + 'vendor_id').val(item.id);
				$(field_id + 'component_type').val(item.primary_component_type);

				// attempt to get ai properties for hotel or show hotel search
				if (item.primary_component_type === 'lodging') {
					getAllInclusiveProperties(day, component, item.id);
				}

				// attempt to get ships for cruise line
				if (item.primary_component_type === 'cruise') {
					getShips(day, component, item.id);
				}

				// handle viator destination
				if (item.name_without_type.indexOf('Viator') !== -1) {
					$('.viator-destination-search[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
					$(field_id + 'viator_destination_id').val('');
					$(field_id + 'viator_destination_search').val('');
					$(field_id + 'viator_destination_search').prop('disabled', false);
				}

				// eslint-disable-next-line no-lonely-if
				if ($(field_id + 'component_type').val() === item.primary_component_type) {
					// eslint-disable-next-line no-lonely-if
					if ($(field_id + 'component_type').val() === 'package') {
						$('.add-details-container[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
						$(field_id + 'details_type').val('');
					} else {
						$('.add-details-container[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
						$(field_id + 'details_type').val(item.primary_component_type);
					}
				} else {
					$('.reset-component-vendor[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');
					Adzuki.StatusMessage('error', 'Sorry, the vendor you chose does not support the component type you selected above.');
					$('.component-type[data-day="' + day + '"][data-component="' + component + '"]').val('');
				}
			},
			null,
			null,
			null,
			true
		);
	}

	function loadViatorDestinationTypeAhead(day, component, component_id)
	{
		var field_id = '#fitbuildertemplatecreatetripsummary-components-' + component_id + '-';

		// viator destination search
		Adzuki.Typeahead(
			field_id + 'viator_destination_search',
			'/Viator/destinationSearch/',
			function select(item, $self, typeahead) {
				// handle response
				typeahead.setHiddenValue(item.destination_id);

				// set hidden viator_destination_id
				$(field_id + 'viator_destination_id').val(item.destination_id);

				// set the search field value, disable, and show reset link
				$(field_id + 'viator_destination_search').val(item.name);
				$(field_id + 'viator_destination_search').prop('disabled', true);

				$('.reset-viator-destination-typeahead[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');

				// show the viator product search field
				$('.viator-search[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
				$(field_id + 'viator_product_code').val('');
				$(field_id + 'viator_product_code').prop('disabled', false);
				$(field_id + 'viator_search').val('');
				$(field_id + 'viator_search').prop('disabled', false);

				// enable viator search
				loadViatorProductTypeAhead(day, component, component_id, item.destination_id);
			},
			null,
			null,
			null,
			true
		);
	}

	function loadViatorProductTypeAhead(day, component, component_id, viator_destination_id)
	{
		var field_id           = '#fitbuildertemplatecreatetripsummary-components-' + component_id + '-',
			product_lookup_url = '/Searches/viator/' + viator_destination_id + '/';

		// viator product search
		Adzuki.Typeahead(
			field_id + 'viator_search',
			product_lookup_url,
			function select(item, $self, typeahead) {
				// handle response
				typeahead.setHiddenValue(item.id);

				// set hidden viator_product_code
				$(field_id + 'viator_product_code').val(item.id);
				$(field_id + 'viator_product_code').prop('disabled', false);

				// set the search field value, disable, and show reset link
				$(field_id + 'viator_search').val(item.name + ' (' + item.id + ')');
				$(field_id + 'viator_search').prop('disabled', true);

				$('.reset-viator-typeahead[data-day="' + day + '"][data-component="' + component + '"]').removeClass('hidden');
			},
			function template(item) {
				var html;

				html = item.name + ' (' + item.id + ')';

				return html;
			},
			null,
			null,
			true
		);
	}

	// reset hotel link
	function resetHotelTypeAhead(day, component, component_id)
	{
		var field_id = '#fitbuildertemplatecreatetripsummary-components-' + component_id + '-';

		// reset component hotel link
		$('.reset-component-hotel[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearDetailLinks(e) {
			e.preventDefault();

			$('.component_hotels[data-day="' + day + '"][data-component="' + component + '"]').val('');
			$('.component_hotels[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
			$('.reset-hotel-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			$(field_id + 'hotel_giata_id').val('');
			$(field_id + 'hotel_giata_id').prop('disabled', false);
		});
	}

	// reset vendor link
	function resetVendorTypeAhead(day, component, component_id)
	{
		var field_id = '#fitbuildertemplatecreatetripsummary-components-' + component_id + '-';

		// reset component vendor link
		$('.reset-component-vendor[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearDetailLinks(e) {
			e.preventDefault();

			$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').val('');
			$('.component_vendors[data-day="' + day + '"][data-component="' + component + '"]').prop('disabled', false);
			$('.reset-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			$(field_id + 'vendor_id').val('');
			$(field_id + 'vendor_id').prop('disabled', false);

			// clear out the ai property and hide it too
			$(field_id + 'all_inclusive_property_id').val('');
			$(field_id + 'all_inclusive_property_id').prop('disabled', true);
			$('.component-ai-property[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// clear out the hotel search and hide it too
			$(field_id + 'hotel_giata_id').val('');
			$(field_id + 'hotel_giata_id').prop('disabled', true);
			$(field_id + 'hotel_search').val('');
			$(field_id + 'hotel_search').prop('disabled', true);
			$('.component-hotel[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// clear out the ship and hide it too
			$(field_id + 'ship_id').val('');
			$(field_id + 'ship_id').prop('disabled', true);
			$('.component-ship[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// clear out the viator fields and hide them too
			$(field_id + 'viator_destination_id').val('');
			$(field_id + 'viator_destination_id').prop('disabled', true);
			$(field_id + 'viator_destination_search').val('');
			$(field_id + 'viator_destination_search').prop('disabled', true);
			$(field_id + 'viator_product_code').val('');
			$(field_id + 'viator_product_code').prop('disabled', true);
			$(field_id + 'viator_search').val('');
			$(field_id + 'viator_search').prop('disabled', true);
			$('.component-viator[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		});
	}

	// reset viator destination/product links
	function resetViatorTypeAheads(day, component, component_id)
	{
		var field_id = '#fitbuildertemplatecreatetripsummary-components-' + component_id + '-';

		// reset component viator destination link
		$('.reset-component-viator-destination[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearViatorDestination(e) {
			e.preventDefault();

			$(field_id + 'viator_destination_id').val('');
			$(field_id + 'viator_destination_id').prop('disabled', false);
			$(field_id + 'viator_destination_search').val('');
			$(field_id + 'viator_destination_search').prop('disabled', false);

			// hide reset link
			$('.reset-viator-destination-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');

			// trigger product reset
			$('.reset-component-viator[data-day="' + day + '"][data-component="' + component + '"]').trigger('click');

			// hide the product search, only shows when destination selected
			$('.viator-search[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		});

		// reset component viator product link
		$('.reset-component-viator[data-day="' + day + '"][data-component="' + component + '"]').click(function _clearViatorProduct(e) {
			e.preventDefault();

			$(field_id + 'viator_product_code').val('');
			$(field_id + 'viator_product_code').prop('disabled', false);
			$(field_id + 'viator_search').val('');
			$(field_id + 'viator_search').prop('disabled', false);

			// hide reset link
			$('.reset-viator-typeahead[data-day="' + day + '"][data-component="' + component + '"]').addClass('hidden');
		});
	}

	function showImagePicker(day = null, component = null)
	{
		var $image_library_preview,
			$id_picture,
			$id_library_image,
			$id_remove_picture,
			$selected_image,
			$selected_image_remove,
			day_index,
			component_index,
			field_id;

		// change the element references based on having day/component or not
		if (day !== null && component !== null) {
			day_index              = String(day - 1);
			component_index        = String(component - 1);
			field_id               = '#fitbuildertemplatecreatetripsummary-days-' + day_index + '-components-' + component_index + '-';
			$image_library_preview = $('.image-library-preview[data-day="' + day + '"][data-component="' + component + '"]');
			$id_picture            = $(field_id + 'component_picture');
			$id_library_image      = $(field_id + 'component_library_image');
			$id_remove_picture     = $(field_id + 'remove_component_picture');
			$selected_image        = $('.selected-component-image[data-day="' + day + '"][data-component="' + component + '"]');
			$selected_image_remove = $('.selected-component-image-remove[data-day="' + day + '"][data-component="' + component + '"]');
		} else {
			$image_library_preview = $('.image-library-preview');
			$id_picture            = $('#fitbuildertemplatecreatetripsummary-picture');
			$id_library_image      = $('#fitbuildertemplatecreatetripsummary-library_image');
			$id_remove_picture     = $('#fitbuildertemplatecreatetripsummary-remove_picture');
			$selected_image        = $('.selected-image');
			$selected_image_remove = $('.selected-image-remove');
		}

		$image_library_preview.attr('src', '');

		$modal.addClass('wide');
		$modal.find('.modal-title').text('Image Library');
		$modal.find('.modal-body').text('Loading image library...');

		Adzuki.Ajax.get('/Images/imagePicker')
		.then(function _showImagePicker(html) {
			$modal.find('.modal-body').html(html);

			Adzuki.Form.initAjaxForm('ImageSearch');
		});

		$modal.on('click', '.image-picker .select-image', function selectImage() {
			var $image = $(this).parents('.image-container').find('img'),
				$src   = $image.attr('src');

			$id_picture.val('');
			$id_library_image.val($src);
			$id_remove_picture.val('');
			$selected_image.attr('src', $src);

			$selected_image_remove.removeClass('hidden');

			$modal.modal('hide');
		});

		$modal.on('click', '.add-button-btn', function addImageButtonPressed() {
			Adzuki.CustomConfirm({
				title  : 'Add image?',
				content: 'Adding images must be done through the Image section of the web program. Clicking \'Ok\' will take you there now. Would you like to go? Please note any unsaved work may be lost.',
				confirm: function confirm() {
					document.location = Adzuki.webprogram_url + Adzuki.base_uri + '/Images/add/';
				}
			});
		});

		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal')
				  .off('click', '.image-picker .select-image');
		}).modal('show');
	}
}(jQuery, window.Adzuki || {}));
